export const duration = (state) => {
  const minutes = state.duration / 60;
  return Math.floor(minutes);
};

export default state => state;



// WEBPACK FOOTER //
// ./src/screens/Class/Content/store/getters.js